import { Flex, Link, RichEditorView } from '@approvalmax/ui/src/components';
import { DoneIcon } from 'modules/sprites';

import { CustomFieldCellComponentProps } from './CustomFieldCellComponent.types';

export const CustomFieldCellComponent = (props: CustomFieldCellComponentProps) => {
    const { value, field } = props;

    if (!value) {
        return null;
    }

    if (field.fieldType === 'Hyperlink') {
        return value && typeof value === 'string' ? (
            <Link href={value} font='body' external>
                {value}
            </Link>
        ) : null;
    }

    if (field.fieldType === 'CheckBox') {
        return value === 'true' ? (
            <Flex alignItems='center'>
                <DoneIcon width={13} height={10} />
            </Flex>
        ) : null;
    }

    if (field.fieldType === 'RichText') {
        return <RichEditorView html={value} />;
    }

    return value;
};

CustomFieldCellComponent.displayName = 'CustomFieldCellComponent';
